"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMonthText = exports.defaultWeekDaysText = exports.CALENDAR_WEEKS = exports.CUR_MONTH = exports.CUR_YEAR = void 0;
exports.CUR_YEAR = new Date().getFullYear();
exports.CUR_MONTH = new Date().getMonth();
exports.CALENDAR_WEEKS = 6;
exports.defaultWeekDaysText = [
    'Su',
    'Mo',
    'Tu',
    'We',
    'Th',
    'Fr',
    'Sa',
];
exports.defaultMonthText = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
